// Effect 4 — Score count-up. Numbers ticking up beats numbers appearing. Nearly free, huge payoff.
//
// NOTE: this drives a neutral "rig tally" (counts characters accepted) purely to demonstrate the
// count-up MOTION. It is NOT game scoring — scoring is gameplay and stays locked in BRIEF.md.
import { feel } from "../feel";
import { tween, easeOutCubic } from "../anim";
import { registerEffect } from "../registry";
import { intensity, timed } from "../../tuner/scale";

let tally = 0;

export function registerCountup(): void {
  registerEffect(
    { name: "countup", label: "4 · Count-up" },
    "word:valid",
    ({ word }) => {
      const el = document.getElementById("rig-tally");
      if (!el) return;
      const from = tally;
      const to = tally + word.length;
      tally = to;
      // intensity scales the count-up duration (higher = longer, more dramatic roll).
      void tween(timed(feel.countup.durationMs * intensity(feel.countup)), easeOutCubic, (v) => {
        el.textContent = String(Math.round(from + (to - from) * v));
      });
    },
  );
}
